import { Injectable } from '@angular/core';
import { catchError, Observable, of, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {
  DetailExpiredPortfolio,
  ExpiredPortfolioPaged,
} from '../../models/expired-portfolio/expired-portfolio.model';
import { PagedFilter } from '../../models/components-general/general-filter.model';
import { GeneralService } from '../general.service';

@Injectable({
  providedIn: 'root',
})
export class ExpiredPortfolioService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public getExpiredPortfolio(pagedFilter: PagedFilter): Observable<ExpiredPortfolioPaged | null> {
    const params = this.generalService.buildParams(pagedFilter);
    return this.http
      .get<ExpiredPortfolioPaged>(this.URL_API + '/GetExpiredPortfolioClientPaged', { params })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public GetDetailExpiredPortfolioClient(clientId: number): Observable<DetailExpiredPortfolio[]> {
    return this.http
      .get<DetailExpiredPortfolio[]>(this.URL_API + `/GetDetailExpiredPortfolioClient/${clientId}`)
      .pipe(
        take(1),
        catchError((error) => {
          console.error('Error fetching detail expired portfolio:', error);
          return of([]);
        }),
      );
  }
}
